import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/sharp-solid-svg-icons";
import React from "react";

interface StringDetailsProps {
  label: string;
  value: string;
  info?: string;
}

const StringDetails: React.FC<StringDetailsProps> = ({
  label,
  value,
  info,
}) => {
  return (
    <div className="flex justify-between">
      <div className="flex items-center gap-1  homepage-text-sm ">
        <span>{label}</span>
        {info && (
          <FontAwesomeIcon
            className="size-3.5 text-gray-400"
            icon={faCircleInfo}
          />
        )}
      </div>
      <div className="homepage-text-sm">{value}</div>
    </div>
  );
};

export default StringDetails;
